import {
  Component,
  HostBinding,
  NgZone,
  OnInit,
} from '@angular/core';
import { LMColumnsBaseComponent } from './lm-columns-base.component';
import { LMConditionUtilService } from '@utils/lm-condition-util.service';
import { LMLayoutUtilDirective } from './lm-layout-util.directive';
import { LMFormLayoutService } from '@form/services/lm-form-layout.service';
import { LMFormatUtilService } from '@services/utils';
import { LMGlobalPersonalizationService } from '@states/services';
import { LMLoggerService } from '@app/services';

@Component({
  selector: 'lm-columns-table',
  templateUrl: 'lm-columns-table.component.html',
  styleUrls: [ 'lm-columns-table.component.scss' ],
  providers: [ LMLayoutUtilDirective, LMFormLayoutService ]
})

export class LMColumnsTableComponent extends LMColumnsBaseComponent implements OnInit {

  @HostBinding('style.width.px') hostWidth: string;
  @HostBinding('class.is-compact-form-layout') useCompactFormLayout: boolean;
  @HostBinding('class.is-in-dashboard') isInDashboard: boolean;

  public rows = [];
  public rowHeaders = [];
  public columnHeaders: Array<LMTableLayoutHeader> = [];
  public distributed: boolean;
  public nbrColumns: number;

  constructor(
    protected lmConditionUtilService: LMConditionUtilService,
    protected lmFormLayoutService: LMFormLayoutService,
    protected lmLoggerService: LMLoggerService,
    private ngZone: NgZone,
    private lmLayoutUtil: LMLayoutUtilDirective,
    private lmFormatUtilService: LMFormatUtilService,
    private lmGlobalPersonalizationService: LMGlobalPersonalizationService
  ) {
    super(lmConditionUtilService, lmFormLayoutService, lmLoggerService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.build();

    this.useCompactFormLayout = this.lmGlobalPersonalizationService.getGlobalPersonalization().useCompactFormLayout;
    this.isInDashboard = (this.lmColumnLayoutInfo && this.lmColumnLayoutInfo.isInDashboard) ? this.lmColumnLayoutInfo.isInDashboard : null;
  }

  private build() {
    this.distributed = this.layoutObject.distributed;
    this.nbrColumns = this.layoutObject.nbrColumns;

    if (this.layoutObject.rowHeaders) {
      this.rowHeaders = this.layoutObject.rowHeaders.map(this.formatHeaders, this);
    }

    if (this.layoutObject.columnHeaders) {
      this.layoutObject.columnHeaders.forEach((column, i) => {
        column.index = i;
      });

      this.columnHeaders = this.layoutObject.columnHeaders.map(this.formatHeaders, this);
    }

    if (this.rowHeaders && this.layoutObject.rows) {
      const rows = [...this.layoutObject.rows].map((row, i) => {
        // Add table header to beginning of the row if it does not already exist
        if (row.elements.length > 0 && row.elements[0].tableHeader === undefined && this.rowHeaders.length !== 0) {
          row.elements.unshift(this.rowHeaders[i]);
        }

        row.index = i;

        return row;
      });

      this.rows = rows;
    } else {
      this.layoutObject.rows.forEach((row, i) => {
        row.index = i;
      });
      this.rows = this.layoutObject.rows;
    }
  }

  private formatHeaders(header) {
    if (header && header.tableHeader && header.tableHeader.text && header.tableHeader.text.variables) {
      const messageRule = header.tableHeader.text;
      header.tableHeader.text.resourceValue = this.lmFormatUtilService.formatMessageRule(messageRule, this.model, this.specFields);
    }
    return header;
  }
}
